import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DatetimePickerComponent } from './datetime-picker.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { FormsModule } from '@angular/forms'
import { TimepickerModule } from 'ngx-bootstrap/timepicker'
import { PopCardModule } from '../../modules/pop-card/pop-card.module'
import { PopoverModule } from 'ngx-bootstrap/popover'

@NgModule({
  declarations: [
    DatetimePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TimepickerModule.forRoot(),
    NgbModule,
    PopCardModule,
    PopoverModule,
  ],
  exports: [
    DatetimePickerComponent
  ]

})
export class DatetimePickerModule {}
